'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _nuiIntl = require('@concur/nui-intl');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _listingModule = require('./listingModule');

var _trackClick = require('../HOCs/trackClick');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  overlay: {
    zIndex: '100',
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content: {
    position: 'initial',
    width: '600px',
    maxHeight: '80%',
    margin: '75px auto'
  }
};

var ConfirmationModal = function ConfirmationModal(_ref) {
  var isConfirmationModalOpen = _ref.isConfirmationModalOpen,
      modalNames = _ref.modalNames,
      toggle = _ref.toggle,
      options = _ref.options,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      listingData = _ref.listingData;

  var toggleThisModal = function toggleThisModal() {
    return toggle(modalNames.confirmation);
  };
  var listingName = void 0;
  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  var getModalHeader = function getModalHeader() {
    if (options.listingType === 'ACONCT') {
      return options.disconnectSuccess ? _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'UnenrollSuccessful' }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'UnenrollFail' });
    }
    return options.disconnectSuccess ? _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'DisconnectSuccessful' }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'DisconnectFail' });
  };

  var getModalBody = function getModalBody() {
    return options.disconnectSuccess ? _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-1' },
        _react2.default.createElement('span', { className: 'confirmation-icon icon-messaging-success icon-size-lg', style: { color: '#3A7827' } })
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-xs-11', style: { paddingTop: '17px' } },
        options.listingType === 'ACONCT' ? _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'UnenrollSuccessfulMessage' }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'DisconnectSuccessfulMessage' })
      )
    ) : _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-1' },
        _react2.default.createElement('span', { className: 'confirmation-icon icon-messaging-error icon-size-lg', style: { color: '#CE202D' } })
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-xs-11', style: { paddingTop: '17px' } },
        options.listingType === 'ACONCT' ? _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'UnenrollFailMessage' }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'DisconnectFailMessage' })
      )
    );
  };

  _reactModal2.default.setAppElement('#root');
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _reactModal2.default,
      {
        style: style,
        isOpen: isConfirmationModalOpen,
        onRequestClose: toggleThisModal,
        contentLabel: 'Confirmation Modal'
      },
      _react2.default.createElement(
        'div',
        { className: 'row inside-modal' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-11' },
          _react2.default.createElement(
            'h3',
            null,
            getModalHeader()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-1' },
          _react2.default.createElement(
            'span',
            {
              className: 'close-tandc-modal pull-right',
              onClick: toggleThisModal
            },
            '\xD7'
          )
        )
      ),
      _react2.default.createElement('hr', null),
      getModalBody(),
      _react2.default.createElement('hr', null),
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            _trackClick.Tracked,
            {
              event: 'CLICK',
              additional: {
                context: 'LISTING_DETAILS',
                type: 'BUTTON',
                value: 'DISCONNECT_CONF_MODAL_OK',
                v2_listing_id: listingId,
                app_name: listingName,
                domain: window.location.hostname
              }
            },
            _react2.default.createElement(
              'button',
              {
                style: { width: '110px', marginLeft: '10px' },
                className: 'btn btn-lg btn-default pull-right',
                onClick: toggleThisModal
              },
              _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Ok' })
            )
          )
        )
      )
    )
  );
};

var mapStateToConfirmationProps = function mapStateToConfirmationProps(state) {
  return {
    isConfirmationModalOpen: state.listing.isConfirmationModalOpen,
    listingData: state.listing,
    modalNames: state.listing.modalNames,
    options: state.listing.modalOptions
  };
};

ConfirmationModal.propTypes = {
  isConfirmationModalOpen: _propTypes2.default.bool.isRequired,
  modalNames: _propTypes2.default.object.isRequired,
  options: _propTypes2.default.object.isRequired,
  toggle: _propTypes2.default.func.isRequired,
  listingId: _propTypes2.default.string,
  v1ListingId: _propTypes2.default.string,
  listingData: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(mapStateToConfirmationProps, {
  toggle: _listingModule.toggleModal
})(ConfirmationModal);


//////////////////
// WEBPACK FOOTER
// ./lib/listing/ConfirmationModal.js
// module id = 594
// module chunks = 0